import { render, staticRenderFns } from "./MAccess.vue?vue&type=template&id=8f086a6c&scoped=true"
import script from "./MAccess.vue?vue&type=script&lang=js"
export * from "./MAccess.vue?vue&type=script&lang=js"
import style0 from "./MAccess.vue?vue&type=style&index=0&id=8f086a6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f086a6c",
  null
  
)

export default component.exports